<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header (onExportToPdf)="downloadUsersByRole('pdf')" (onExportToXls)="downloadUsersByRole('xlsx')" >
      <div slot="leadingWidgets">
        <div class="d-flex flex-column flex-md-row">
          <div class="input-group me-3 mb-3 mb-md-0">
            <app-search-rounded [placeholder]="t('explore.search')"
                                (searchEmitter)="handleInput($event)"></app-search-rounded>
          </div>
          <div class="w-180 d-flex align-items-center">
            <app-select [hasDefault]="true" [items]="roles" [ngModel]="selectedRole"
                        (ngModelChange)="onRoleSelect($event)" [defaultValue]="undefined"
                        [defaultLabel]="t('app.common.all')" labelKeyPrefix="app.common.user.role."
                        [fullWidthDropdown]="true"/>
          </div>
        </div>
      </div>
    </app-admin-actions-header>
    <div>
      <app-loader [isLoading]="isLoading"></app-loader>
      @if (users.length > 0) {
        <div>
          <div class="table-responsive d-xl-block d-none">
            <app-sortable-table cssClass="table dark-header table-last-row-no-border" [items]="users">
              <thead>
              <tr>
                <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t("event.item.id") }}
                </th>
                <th scope="col" [sortBy]="['firstname','lastname']">{{ t("app.common.name.surname") }}
                </th>
                <th scope="col" [sortBy]="['phoneNumber']">{{ t("app.common.mobilePhone") }}</th>
                <th scope="col" [sortBy]="['email']">{{ t("app.common.email") }}</th>
                <th scope="col" class="role-column-width">{{ t("app.common.role") }}</th>
                <th class="icon-column-width"></th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (user of users;track trackByFn) {
                  <tr>
                    <td class="center-align">{{ user.userId }}</td>
                    <td class="center-align">{{ user.firstname ?? "" }} {{ user.lastname ?? "" }}</td>
                    <td class="center-align">
                      @if (user.phoneNumber) {
                        <a class="text-black" href="tel:{{user.phoneNumber}}">{{ user.phoneNumber }}</a>
                      } @else {
                        -
                      }
                    </td>
                    <td class="center-align" matTooltip="{{user.email ?? '-'}}">
                      @if (user.email) {
                        <a class="text-black" href="mailto:{{user.email}}" target="_blank"
                           rel="noopener noreferrer">{{ user.email }}</a>
                      } @else {
                        -
                      }
                    </td>
                    <td class="center-align">
                      <div class="status-badge"
                           [ngClass]="{'accepted': user.role === 'ROLE_ORGANISER', 'denied': user.role === 'ROLE_ADMINISTRATOR',
                          'on-hold': user.role === 'ROLE_DIGI', 'publishing': user.role === 'ROLE_HELPER', 'blue': user.role === 'ROLE_USER'}">
                    <span>
                      {{ user.role | role | uppercase }}
                    </span>
                      </div>
                    </td>
                    <td class="text-end center-align">
                      <span class="menu-icon" (click)="openUserDetails(user)"><i class="fas fa-eye"></i></span>
                    </td>
                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div>
          <!--      Mobile table-->
          <div>
            @for (user of users;let isLast = $last;track trackByFn) {
              <div class="d-block d-xl-none">
                <div [class.isLastRow]="isLast"
                     class="d-flex justify-content-center align-items-center mobile-table-row">
                  <div class="flex-grow-1">
                    <div [class.isLastRow]="isLast" class="d-flex flex-column">
                      <div>
                        <strong>{{ t("event.item.id") }}:</strong> {{ user.id }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.first.name") }}:</strong> {{ user.firstname ?? "-" }}
                      </div>
                      <div>
                        <strong>{{ t("app.common.last.name") }}:</strong> {{ user.lastname ?? "-" }}
                      </div>
                      <div>
                      </div>
                      <div>
                        <strong>{{ t("app.common.mobilePhone") }}:</strong> {{ user.phoneNumber ?? "-" }}
                      </div>

                      <div>
                        <strong>{{ t("app.common.email") }}:</strong> {{ user.email ?? "-" }}
                      </div>

                      <div>
                        <strong>{{ t("app.common.role") }}:</strong> {{ user.role| role | uppercase }}
                      </div>

                    </div>
                  </div>
                  <div>
                    <span class="menu-icon" (click)="openUserDetails(user)"><i class="fas fa-eye"></i></span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="pt-2 pb-4">
          <app-empty-state/>
        </div>
      }
      @if (hasMoreUsers && !isLoading) {
        <div class="d-flex justify-content-center load-more-wrapper pt-2 pb-2">
          <app-rounded-button [label]="t('app.common.load.more')" (onClick)="loadMore()"/>
        </div>
      }
      @if (showFabButton && (users?.length ?? 0) > 0) {
        <div (click)="scrollToTop()" class="scroll-to-top">
          <i class="bi bi-arrow-up"></i>
        </div>
      }
    </div>
  </div>
</ng-container>
